
export function isNullOrEmpt(value) {
	if (value instanceof Array) {
		if (value == undefined || value == null || value.length == 0) {
			return true
		} else {
			return false
		}
	} else {
		console.log('isNullOrEmpt === ' + value)
		if (value == undefined || value == null || value == "" || value == '') {
			return true
		} else {
			return false
		}
	}
}

export function currentTime() {
	// 创建一个新的Date对象来获取当前时间
	const now = new Date();
	// 获取年、月、日、小时、分钟和秒
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1); // 月份从0开始，需要加1，并使用padStart补零
	const day = String(now.getDate());
	const hours = String(now.getHours());
	const minutes = String(now.getMinutes());
	const seconds = String(now.getSeconds());
	// 格式化日期时间字符串
	const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	// 返回格式化后的当前时间
	return formattedTime;
}


export function queryTime(hour) {
	const timestamp = new Date().getTime()
	const now = new Date(timestamp + hour * 60 * 60 * 1000);
	// 获取年、月、日、小时、分钟和秒
	const year = now.getFullYear();
	var month = String(now.getMonth() + 1) // 月份从0开始，需要加1，并使用padStart补零
	var day = String(now.getDate());
	var hours = String(now.getHours());
	var minutes = String(now.getMinutes());
	var seconds = String(now.getSeconds());
	// 格式化日期时间字符串
	if (parseInt(month) < 10) {
		month = "0" + month
	}

	if (parseInt(day) < 10) {
		day = "0" + day
	}

	if (parseInt(hours) < 10) {
		hours = "0" + hours
	}

	if (parseInt(minutes) < 10) {
		minutes = "0" + minutes
	}
	if (parseInt(seconds) < 10) {
		seconds = "0" + seconds
	}
	
	if(month.length>2){
		month = month.substring(1,month.length)
	}
	
	if(day.length>2){
		day = day.substring(1,day.length)
	}
	
	if(hours.length>2){
		hours = hours.substring(1,hours.length)
	}
	
	if(minutes.length>2){
		minutes = minutes.substring(1,minutes.length)
	}
	
	if(seconds.length>2){
		seconds = seconds.substring(1,seconds.length)
	}

	const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	// 返回格式化后的当前时间
	return formattedTime;

}

export function calculateEndTime(startTime, intervalHours) {
	// 将开始时间字符串转换为Date对象
	let start = new Date(startTime);
	// 计算结束时间
	let end = new Date(start.getTime() + intervalHours * 60 * 60 * 1000); // 将小时转换为毫秒

	// 格式化结束时间为ISO字符串
	let endTime = end.toISOString().slice(0, 19).replace('T', ' '); // 转换为"YYYY-MM-DD HH:MM:SS"格式

	return endTime
}

function padDateNumber(value) {
	return String(value).padStart(2, '0')
}

// 获取本月第一天
export function getOneInCurrentMonth() {
	// 获取当前日期
	const now = new Date()
	// 获取当前年份和月份
	const year = now.getFullYear()
	const month = now.getMonth() + 1 // 注意月份从0开始，所以+1
	return `${year}-${padDateNumber(month)}-01`
}

// 获取本月最后一天
export function getDaysInCurrentMonth() {
	// 获取当前日期
	const now = new Date()
	// 获取当前年份和月份
	const year = now.getFullYear()
	const month = now.getMonth() + 1 // 注意月份从0开始，所以+1
	// 下个月的第0天即当前月的最后一天
	const lastDay = new Date(year, month, 0)
	return `${year}-${padDateNumber(month)}-${padDateNumber(lastDay.getDate())}`
}


// 上个月有多少天（第一天）
export function calculateLastMonthOneDate() {
	const now = new Date()
	// 获取当前年份和月份
	const year = now.getFullYear()
	const month = now.getMonth() // 0-11（当前月份）

	// 计算上个月的年份和月份
	let lastMonthYear = year
	let lastMonth = month - 1

	// 如果当前是1月（0），上个月就是去年的12月
	if (lastMonth < 0) {
		lastMonthYear = year - 1
		lastMonth = 11 // 12月
	}

	return `${lastMonthYear}-${padDateNumber(lastMonth + 1)}-01`
}

// 上个月有多少天（最后一天）
export function calculateLastMonthDays() {
	const now = new Date()
	// 获取当前年份和月份
	const year = now.getFullYear()
	const month = now.getMonth() // 0-11（当前月份）

	// 计算上个月的年份和月份
	let lastMonthYear = year
	let lastMonth = month - 1

	// 如果当前是1月（0），上个月就是去年的12月
	if (lastMonth < 0) {
		lastMonthYear = year - 1
		lastMonth = 11 // 12月
	}

	// 获取上个月的最后一天（当月的第0天）
	const lastDayOfLastMonth = new Date(lastMonthYear, lastMonth + 1, 0)
	return `${lastMonthYear}-${padDateNumber(lastDayOfLastMonth.getMonth() + 1)}-${padDateNumber(lastDayOfLastMonth.getDate())}`
}

// 计算上月同期
export function calculateLastMonthSamePeriod(dateStr) {
	const date = parseDate(dateStr)

	// 获取年月日时分秒
	const year = date.getFullYear()
	const month = date.getMonth() // 0-11
	const day = date.getDate()
	const hours = date.getHours()
	const minutes = date.getMinutes()
	const seconds = date.getSeconds()

	// 计算上月同期
	let lastMonthYear = year
	let lastMonth = month - 1

	// 如果月份是0（1月），上月就是上一年12月
	if (lastMonth < 0) {
		lastMonthYear = year - 1
		lastMonth = 11 // 12月
	}
	// 创建上月同期日期
	let lastMonthDate = new Date(lastMonthYear, lastMonth, day, hours, minutes, seconds)	      
	      // 处理边界情况：如果原始日期是某月最后一天（如3月31日），上月可能没有31号
	      // 这种情况下，取上个月的最后一天
	      if (lastMonthDate.getMonth() !== lastMonth) {
	        // 获取上个月的最后一天
	        const lastDayOfLastMonth = new Date(lastMonthYear, lastMonth + 1, 0).getDate()
	        lastMonthDate = new Date(lastMonthYear, lastMonth, lastDayOfLastMonth, hours, minutes, seconds)
	      }
	      
	return formatDate(lastMonthDate)
}



// 计算去年同期
export function calculateLastYearSamePeriod(dateStr) {
	const date = parseDate(dateStr)
	const year = date.getFullYear()
	const month = date.getMonth()
	const day = date.getDate()
	const hours = date.getHours()
	const minutes = date.getMinutes()
	const seconds = date.getSeconds()

	
	// 去年同期（年份减1）
	let lastYearDate = new Date(year - 1, month, day, hours, minutes, seconds)
	// 处理闰年2月29日的情况
	// 如果原始日期是2月29日，且去年不是闰年，则调整为2月28日
	if (month === 1 && day === 29) {
			const isLeapYear = (year) => {
			return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)
		}
		if (!isLeapYear(year - 1)) {
			lastYearDate = new Date(year - 1, month, 28, hours, minutes, seconds)
		}
	}
	return formatDate(lastYearDate)
}



/**
 * 格式化日期为 YYYY-MM-DD
 * @param {Date} date 
 * @returns {string}
 */
export function formatDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * 解析日期字符串为 Date 对象
 * @param {string} dateStr YYYY-MM-DD
 * @returns {Date}
 */
export function parseDate(dateStr) {
  if (dateStr instanceof Date) {
    return new Date(dateStr.getFullYear(), dateStr.getMonth(), dateStr.getDate())
  }
  if (typeof dateStr === 'string') {
    const datePart = dateStr.trim().split(' ')[0]
    const parts = datePart.split('-').map((item) => Number(item))
    if (parts.length === 3 && parts.every((item) => !Number.isNaN(item))) {
      return new Date(parts[0], parts[1] - 1, parts[2])
    }
  }
  return new Date(dateStr)
}

/**
 * 计算上月同期日期
 * @param {Date} date 当前日期
 * @returns {Date}
 */
export function getLastMonthSameDate(date) {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  
  // 上月
  const lastMonth = new Date(year, month - 1, 1)
  const lastMonthMaxDay = new Date(year, month, 0).getDate()
  
  // 处理上月天数不足的情况
  const targetDay = Math.min(day, lastMonthMaxDay)
  
  return new Date(year, month - 1, targetDay)
}

/**
 * 计算去年同期日期
 * @param {Date} date 当前日期
 * @returns {Date}
 */
export function getLastYearSameDate(date) {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  
  // 去年
  const lastYear = year - 1
  
  // 处理闰年2月29日的情况
  if (month === 1 && day === 29) {
    // 检查去年是否是闰年
    const isLastYearLeap = (lastYear % 4 === 0 && lastYear % 100 !== 0) || (lastYear % 400 === 0)
    if (!isLastYearLeap) {
      return new Date(lastYear, 1, 28)
    }
  }
  
  return new Date(lastYear, month, day)
}

/**
 * 计算日期范围
 * @param {string} startDateStr 开始日期 YYYY-MM-DD
 * @param {string} endDateStr 结束日期 YYYY-MM-DD
 * @returns {Object}
 */
export function calculatePeriodDates(startDateStr, endDateStr) {
  const startDate = parseDate(startDateStr)
  const endDate = parseDate(endDateStr)
  
  // 计算上月同期
  const lastMonthStart = getLastMonthSameDate(startDate)
  const lastMonthEnd = getLastMonthSameDate(endDate)
  
  // 计算去年同期
  const lastYearStart = getLastYearSameDate(startDate)
  const lastYearEnd = getLastYearSameDate(endDate)
  
  return {
    // 当前选择日期
    currentPeriod: {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    },
    // 上月同期日期
    lastMonthPeriod: {
      startDate: formatDate(lastMonthStart),
      endDate: formatDate(lastMonthEnd)
    },
    // 去年同期日期
    lastYearPeriod: {
      startDate: formatDate(lastYearStart),
      endDate: formatDate(lastYearEnd)
    }
  }
}


export function queryHomeFuncations() {

	const lstFunction = querylstFunction()
	const dataArray = []
	if (lstFunction.concat('300101')) {
		dataArray.push({ name: '开牌', url: '/pages/keycode/openkeycode' })
	}

	if (lstFunction.concat('400117') || lstFunction.concat('400118') || lstFunction.concat('400131')) {
		dataArray.push({ name: '派钟', url: '/pages/jishi/productmain' })
	}

	if (lstFunction.concat('30010112') || lstFunction.concat('30010131')) {
		dataArray.push({ name: '消费录入', url: '/pages/consume/goodmain' })
	}

	if (lstFunction.concat('270109')) {
		dataArray.push({ name: '自助餐', url: '' })
	}

	if (lstFunction.concat('300152') || lstFunction.concat('3001101')) {
		dataArray.push({ name: '撤牌', url: '' })
	}

	if (lstFunction.concat('300111')) {
		dataArray.push({ name: '开房', url: '/pages/room/openroom' })
		dataArray.push({ name: '编辑', url: '/pages/room/busyroom' })
	}

	if (lstFunction.concat('300112')) {
		dataArray.push({ name: '换房', url: '/pages/room/busyroom' })
	}

	if (lstFunction.concat('300108')) {
		dataArray.push({ name: '留房', url: '/pages/room/busyroom' })
	}

	if (lstFunction.concat('30011412')) {
		dataArray.push({ name: '房间预约', url: '/pages/room/querybookrecord' })
	}

	if (lstFunction.concat('300113')) {
		dataArray.push({ name: '退房', url: '/pages/room/busyroom' })
	}

	if (lstFunction.concat('46010103') || lstFunction.concat('46010105') || lstFunction.concat('30010103') || lstFunction.includes('30010105')) {
		dataArray.push({ name: '退赠管理', url: '' })
	}

	if (lstFunction.concat('30010107')) {
		dataArray.push({ name: '单转', url: '/pages/keycode/keycodesingleturn' })
	}

	if (lstFunction.concat('30010401')) {
		dataArray.push({ name: '换手牌', url: '/pages/keycode/keycodechange' })
	}
	dataArray.push({ name: '并牌', url: '/pages/keycode/keycodechange' })
	if (lstFunction.concat('30010401')) {
		dataArray.push({ name: '手牌备注', url: '/pages/keycode/keycodechange' })
	}

	if (lstFunction.concat('30011701')) {
		dataArray.push({ name: '冻结', url: '' })
	}

	if (lstFunction.concat('30011702')) {
		dataArray.push({ name: '解冻', url: '' })
	}

	if (lstFunction.concat('300106')) {
		dataArray.push({ name: '组团', url: '/pages/keycode/keycodegroupbuild' })
	}

	if (lstFunction.concat('300122')) {
		dataArray.push({ name: '拆团', url: '/pages/keycode/breakkeycodegroup' })
	}

	if (lstFunction.concat('1000125')) {
		dataArray.push({ name: '沽清', url: '/pages/guqing/guqing' })
	}

	if (lstFunction.concat('46012912')) {
		dataArray.push({ name: '划菜', url: '' })
	}

	if (lstFunction.concat('10003')) {
		dataArray.push({ name: '排队', url: '' })
	}

	return dataArray
}

export function queryFuncationsForQuery() {

	const lstFunction = querylstFunction()
	const queryArray = []

	if (lstFunction.concat('3001')) {
		queryArray.push({ name: '手牌查询', url: '/pages/keycode/keycodemain' })
	}

	if (lstFunction.concat('30010135')) {
		queryArray.push({ name: '手牌二维码', url: '' })
	}

	if (lstFunction.concat('880114') || lstFunction.concat('30015410')) {
		queryArray.push({ name: '房态查询', url: '/pages/room/roommain' })
	}

	if (lstFunction.concat('880158')) {
		queryArray.push({ name: '客房查询', url: '' })
	}

	if (lstFunction.concat('30010204')) {
		queryArray.push({ name: '账单查询', url: '' })
	}
	return queryArray
}
export function queryHomeFuncationsForJiaoBan() {
	const lstFunction = querylstFunction()
	const jiaobanArray = []
	if (lstFunction.concat('30010501') || lstFunction.concat('97050402')) {
		jiaobanArray.push({ name: '个人交班', url: '/pages/handover/handover' })
	}

	if (lstFunction.concat('970402')) {
		jiaobanArray.push({ name: '个人交班查询', url: '/pages/handover/queryhandover' })
	}

	if (lstFunction.concat('30010502') || lstFunction.concat('97050401')) {
		jiaobanArray.push({ name: '总交班', url: '/pages/handover/handover' })
	}

	if (lstFunction.concat('970402')) {
		jiaobanArray.push({ name: '总交班查询', url: '/pages/handover/queryhandover' })
	}
	return jiaobanArray
}

export function queryHomeFuncationsForJiShi() {
	const lstFunction = querylstFunction()

	const jishiArray = []

	if (lstFunction.concat('4001')) {
		jishiArray.push({ name: '技师钟房', url: '/pages/jishi/jishimain' })
	}

	if (lstFunction.concat('400147')) {
		jishiArray.push({ name: '上钟', url: '/pages/jishi/jishionclock' })
	}

	if (lstFunction.concat('400106') || lstFunction.concat('30015406')) {
		jishiArray.push({ name: '加钟', url: '/pages/jishi/jishiaddclock' })
	}

	if (lstFunction.concat('30015407') || lstFunction.concat('400105')) {
		jishiArray.push({ name: '下钟', url: '/pages/jishi/jishidownclock' })
	}

	if (lstFunction.concat('400112')) {
		jishiArray.push({ name: '换钟', url: '/pages/jishi/jishichangeclock' })
	}

	jishiArray.push({ name: '取消待钟', url: '/pages/jishi/jishicancelwiatclock' })

	if (lstFunction.concat('400107') || lstFunction.concat('30015404')) {
		jishiArray.push({ name: '退钟', url: '/pages/jishi/jishibackclock' })
	}

	if (lstFunction.concat('400110') || lstFunction.concat('400111')) {
		jishiArray.push({ name: '做钟暂停', url: '' })
		jishiArray.push({ name: '做钟继续', url: '' })
	}

	if (lstFunction.concat('400101') || lstFunction.concat('400102')) {
		jishiArray.push({ name: '班次管理', url: '/pages/jishi/jishiduty' })
	}

	return jishiArray
}

export function querylstFunction() {
	const dataArray = []
	const jsonString = uni.getStorageSync('FUNCTION_STRING')
	if (isNullOrEmpt(jsonString)) {

	} else {
		const result = JSON.parse(jsonString)
		dataArray.push(...result.lstFunctionId)
	}
	return dataArray

}
